export default function Divisions() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-thin text-[#002B5C] mb-4 max-w-2xl">
            Our Three Pillars of Excellence
          </h2>
          <p className="text-base text-[#6B7280]">
            Integrated solutions across the scientific spectrum
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div id="medical-devices" className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="bg-[#E3F2FD] p-12 flex items-center justify-center min-h-[280px]">
              <div className="text-center">
                <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center">
                  <i className="ri-cpu-line text-7xl text-[#002B5C]"></i>
                </div>
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-device-line text-6xl text-[#002B5C]"></i>
                </div>
              </div>
            </div>
            <div className="p-8 text-center">
              <h3 className="text-2xl font-bold text-[#002B5C] mb-3">InovaBioTech</h3>
              <p className="text-3xl font-semibold text-[#002B5C] mb-6">
                Medical &amp; Laboratory Equipment
              </p>
              <a
                href="#contact"
                className="inline-block w-4/5 px-6 py-3 bg-[#002B5C] text-white rounded-full text-sm font-medium hover:bg-[#1565C0] transition-colors whitespace-nowrap cursor-pointer"
              >
                View Technology
              </a>
              <p className="text-xs text-[#6B7280] mt-6 uppercase tracking-wide">
                FDA Registered Manufacturing
              </p>
            </div>
          </div>

          <div id="pharmaceuticals" className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="bg-[#F5F5F5] p-12 flex items-center justify-center min-h-[280px]">
              <div className="text-center">
                <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center">
                  <i className="ri-flask-line text-7xl text-[#FFC107]"></i>
                </div>
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-capsule-line text-6xl text-[#FFC107]"></i>
                </div>
              </div>
            </div>
            <div className="p-8 text-center">
              <h3 className="text-2xl font-bold text-[#002B5C] mb-3">InovaBioChem</h3>
              <p className="text-3xl font-semibold text-[#002B5C] mb-6">
                Research Chemical &amp; Pharmaceutical Manufacturing
              </p>
              <a
                href="#contact"
                className="inline-block w-4/5 px-6 py-3 bg-white text-[#002B5C] border-2 border-[#002B5C] rounded-full text-sm font-medium hover:bg-[#002B5C] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                Explore Compounds
              </a>
              <p className="text-xs text-[#6B7280] mt-6 uppercase tracking-wide">
                In the process of FDA Establishment Registration
              </p>
            </div>
          </div>

          <div id="research-labs" className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="bg-[#FFF9E6] p-12 flex items-center justify-center min-h-[280px]">
              <div className="text-center">
                <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center">
                  <i className="ri-microscope-line text-7xl text-[#FFC107]"></i>
                </div>
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-test-tube-line text-6xl text-[#FFC107]"></i>
                </div>
              </div>
            </div>
            <div className="p-8 text-center">
              <h3 className="text-2xl font-bold text-[#002B5C] mb-3">InovaBioLabs</h3>
              <p className="text-3xl font-semibold text-[#002B5C] mb-6">
                Research &amp; Testing Services
              </p>
              <a
                href="#contact"
                className="inline-block w-4/5 px-6 py-3 bg-white text-[#002B5C] border-2 border-[#002B5C] rounded-full text-sm font-medium hover:bg-[#002B5C] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                Contract Services
              </a>
              <p className="text-xs text-[#6B7280] mt-6 uppercase tracking-wide">
                Peer Review &amp; Validation
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}